import { render, staticRenderFns } from "./PapercleanDocumentiListPage.vue?vue&type=template&id=c2048aba"
import script from "./PapercleanDocumentiListPage.vue?vue&type=script&lang=js"
export * from "./PapercleanDocumentiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports